import { chakra } from '@chakra-ui/react';

import { ModalWrapper } from '../../../../../components/modal-wrapper';

export const ErrorModalWrapper = chakra(ModalWrapper, { baseStyle: { flexDirection: 'column' } });
